export default {
    ID: "3",
    SLUG: "milkbun",
    NAME: " Milkbun",
    PRIMARY: "#4BB9EE",
    SECONDARY: "#38c172",
    API: "https://api.milkbun.com",
    LOGO: "/milkbun/logo.png",
    APP_ICON: "/assets/milkbun/milkbun.svg",
    APP_LOGO: "/assets/milkbun/milkbun.svg",
    APP_FAVICON: "/assets/milkbun/favicon.ico",
    APP_NAME: "Milkbun",
  };